import {
    LABEL_URL,
    FILE_URL,
    CONTACTS_URL
  } from "../../../services/common-urls";
  import { MHTTPCL, JSON_STRING } from "../../../services/http/http-client";
 
  const section = 'common'
  
  export const DeactivateService = {

    //label section

    changeLabelStatusToDeactive:(label_id,status_id,termination_date)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        label_id:label_id,
        status_id:status_id,
        termination_date:termination_date,
        output: JSON_STRING
    }),

    changeLabelAndRelatedStatusToDeactive:(label_id,status_id,termination_date,change_related_items=1)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        label_id:label_id,
        status_id:status_id,
        termination_date:termination_date,
        change_related_items:change_related_items,
        output: JSON_STRING
    }),

    changeLabelStatusToActive:(label_id,status_id)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        label_id:label_id,
        status_id:status_id,
        output: JSON_STRING
    }),

    changeLabelAndRelatedStatusToActive:(label_id,status_id,change_related_items=1)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        label_id:label_id,
        status_id:status_id,
        change_related_items:change_related_items,
        output: JSON_STRING
    }),


    //https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&label_id=737&status_id=47&change_related_items=1&output=json

    
    //release section
     // https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&release_id=10177&status_id=6&termination_date=2024-05-01&output=json
    changeReleaseStatusToDeactive:(release_id,status_id,termination_date)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        release_id:release_id,
        status_id:status_id,
        termination_date:termination_date,
        output: JSON_STRING
    }),

    //https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&release_id=10177&status_id=6&termination_date=2024-05-02&change_related_items=1&output=json

    changeReleaseAndRelatedStatusToDeactive:(release_id,status_id,termination_date,change_related_items=1)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        release_id:release_id,
        status_id:status_id,
        termination_date:termination_date,
        change_related_items:change_related_items,
        output: JSON_STRING
    }),

    //https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&release_id=10177&status_id=5&output=json

    changeReleaseStatusToActive:(release_id,status_id)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        release_id:release_id,
        status_id:status_id,
        output: JSON_STRING
    }),

    //https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&release_id=10177&status_id=5&change_related_items=1&output=json

    changeReleaseAndRelatedStatusToActive:(release_id,status_id,change_related_items=1)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        release_id:release_id,
        status_id:status_id,
        change_related_items:change_related_items,
        output: JSON_STRING
    }),


    //https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&product_id=13700&status_id=46&termination_date=2024-05-01&output=json
    changeProductStatusToDeactive:(product_id,status_id,termination_date)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        product_id:product_id,
        status_id:status_id,
        termination_date:termination_date,
        output: JSON_STRING
    }),

    //https://dev.berlin3.com/updatecheck2/label.pl?section=common&action=change_label_status&product_id=13700&status_id=16&output=json

    changeProductStatusToActive:(product_id,status_id)=>MHTTPCL.post(LABEL_URL,{
        section:section,
        action:'change_label_status',
        product_id:product_id,
        status_id:status_id,
        output: JSON_STRING
    }),
  };